import { useMutation } from "@tanstack/react-query";
import {
  CreateItemStockUnitFormType,
  CreateItemStockUnitResponse,
  DeleteItemStockUnitRequestBody,
  DeleteItemStockUnitResponse,
  EditItemStockUnitFormType,
  EditItemStockUnitResponse,
} from "./interfaces";

import queryClient from "src/config/reactQuery.config";
import {
  createItemStockUnit,
  deleteItemStockUnit,
  editItemStockUnit,
} from "src/services/ItemStockUnit.service";

export const useCreateItemStockUnit = () => {
  return useMutation<
    CreateItemStockUnitResponse,
    Error,
    CreateItemStockUnitFormType
  >({
    mutationFn: (value) => createItemStockUnit(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["item-stock-unit"] });
    },
  });
};

export const useEditItemStockUnit = () => {
  return useMutation<
    EditItemStockUnitResponse,
    Error,
    EditItemStockUnitFormType
  >({
    mutationFn: (value) => editItemStockUnit(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["item-stock-unit"] });
    },
  });
};

export const useDeleteItemStockUnit = () => {
  return useMutation<
    DeleteItemStockUnitResponse,
    Error,
    DeleteItemStockUnitRequestBody
  >({
    mutationFn: (value) => deleteItemStockUnit(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["item-stock-unit"] });
    },
  });
};
